export default __webpack_public_path__ + "static/media/candidate_not_active.d8414a98.svg";